import _ from 'lodash'
import { normalize } from 'normalizr'
import { Alert } from './schema'
import Vue from 'vue'
import updateBucketState from '@/store/utils/updateBucketState'

export {
  RESET_CURRENT_DASHBOARD,
  SET_CURRENT_DASHBOARD,
  SET_HOVERED_COMPONENT,
  UPDATE_CURRENT_DASHBOARD,
  REMOVE_DASHBOARD_ITEM,
  SET_COMPONENT_BEING_EDITED_PARAM,
  SET_IS_COMPONENT_PICKER_OPEN,
  SET_EDIT_DIALOG_INTENT,
  SET_COMPONENT_BEING_EDITED,
  APPLY_CHANGES_TO_COMPONENT_BEING_EDITED,
  ADD_COMPONENT_TO_DASHBOARD,
} from './modules/kpiDashboard'
export const SET_BUCKET = 'SET_BUCKET'
export const SET_CURRENT_BUCKET_ID = 'SET_CURRENT_BUCKET_ID'
export const SET_CURRENT_APP_NAME = 'SET_CURRENT_APP_NAME'
export const UPDATE_SERVER = 'UPDATE_SERVER'
export const SET_USER = 'SET_USER'
export const SET_STATUS = 'SET_STATUS'
export const SET_SERVERS_COUNT = 'SET_SERVERS_COUNT'
export const SET_APPS_COUNT = 'SET_APPS_COUNT'
export const SET_PLANS = 'SET_PLANS'
export const SET_HAS_SEEN_WIZARD = 'SET_HAS_SEEN_WIZARD'
export const SET_THEME = 'SET_THEME'
// PROFILING
export const ADD_CPU_PROFILE = 'ADD_CPU_PROFILE'
export const UPDATE_CPU_PROFILE = 'UPDATE_CPU_PROFILE'
export const CLEAR_CPU_PROFILES = 'CLEAR_CPU_PROFILES'
export const CLEAR_HEAP_PROFILES = 'CLEAR_HEAP_PROFILES'
export const CLEAR_MEM_SNAPSHOTS = 'CLEAR_MEM_SNAPSHOTS'
export const ADD_MEM_SNAPSHOT = 'ADD_MEM_SNAPSHOT'
export const UPDATE_MEM_SNAPSHOT = 'UPDATE_MEM_SNAPSHOT'
export const ADD_HEAP_PROFILE = 'ADD_HEAP_PROFILE'
export const UPDATE_HEAP_PROFILE = 'UPDATE_HEAP_PROFILE'
export const SET_PROFILING_HISTORY = 'SET_PROFILING_HISTORY'
export const DELETE_PROFILING = 'DELETE_PROFILING'
//
export const SET_TOKENS = 'SET_TOKENS'
export const ADD_TOKEN = 'ADD_TOKEN'
export const REMOVE_TOKEN = 'REMOVE_TOKEN'
export const SET_OTP = 'SET_OTP'
export const REMOVE_PROVIDER = 'REMOVE_PROVIDER'
export const UPDATE_ALERTS = 'UPDATE_ALERTS'
export const UPDATE_SLACK = 'UPDATE_SLACK'
export const UPDATE_WEBHOOK = 'UPDATE_WEBHOOK'
export const SET_CRITICAL_RESOURCES_FETCHED = 'SET_CRITICAL_RESOURCES_FETCHED'
export const SET_BILLING_CARDS = 'SET_BILLING_CARDS'
export const ADD_BILLING_CARD = 'ADD_BILLING_CARD'
export const REMOVE_BILLING_CARD = 'REMOVE_BILLING_CARD'
export const SET_DEFAULT_BILLING_CARD = 'SET_DEFAULT_BILLING_CARD'
export const SET_BILLING_INVOICES = 'SET_BILLING_INVOICES'
export const SET_BILLING_RECEIPTS = 'SET_BILLING_RECEIPTS'
export const SET_BILLING_YEARLY = 'SET_BILLING_YEARLY'
export const SET_BILLING_COUPON = 'SET_BILLING_COUPON'
export const SET_BILLING_META = 'SET_BILLING_META'
export const SET_BILLING_META_VATNUMBER = 'SET_BILLING_META_VATNUMBER'
export const SET_BILLING_META_COMPANYNAME = 'SET_BILLING_META_COMPANYNAME'
export const SET_BILLING_META_RECEIPTEMAIL = 'SET_BILLING_META_RECEIPTEMAIL'
export const SET_PAGE_LOADING = 'SET_PAGE_LOADING'
export const SET_APP_OUTLIERS = 'SET_APP_OUTLIERS'
export const SET_PREFERRED_METRICS = 'SET_PREFERRED_METRICS'
export const SET_SELECTED_VARIANCE = 'SET_SELECTED_VARIANCE'
export const REMOVE_BUCKET_CREATION_MAIL = 'REMOVE_BUCKET_CREATION_MAIL'
export const SET_AUTHORIZED_USERS = 'SET_AUTHORIZED_USERS'
export const REMOVE_AUTHORIZED_USER = 'REMOVE_AUTHORIZED_USER'
export const SET_USER_NOTIFICATION = 'SET_USER_NOTIFICATION'
export const SET_USER_ROLE = 'SET_USER_ROLE'
export const SET_INVITATIONS = 'SET_INVITATIONS'
export const UPDATE_BUCKET = 'UPDATE_BUCKET'
export const UPDATE_BUCKET_NAME = 'UPDATE_BUCKET_NAME'
export const UPDATE_BUCKET_COMMENT = 'UPDATE_BUCKET_COMMENT'
export const UPDATE_LOCALE = 'UPDATE_LOCALE'
export const DELETE_BUCKET = 'DELETE_BUCKET'
export const ADD_LINKED_SERVER = 'ADD_LINKED_SERVER'
export const SET_ACTIVATE_PM2 = 'SET_ACTIVATE_PM2'
export const SET_UPGRADE_STEPPER = 'SET_UPGRADE_STEPPER'
export const SET_PROCESS_BLACKLIST = 'SET_PROCESS_BLACKLIST'
export const REMOVE_SERVER = 'REMOVE_SERVER'
export const ADD_EMITTED_EVENT = 'ADD_EMITTED_EVENT'
export const SET_IS_PORTAL_OPEN = 'SET_IS_PORTAL_OPEN'
export const UPDATE_TIMESTAMP = 'UPDATE_TIMESTAMP'
export const SET_NAV_TO_HINT = 'SET_NAV_TO_HINT'
export const SET_REALTIME_ISSUES = 'SET_REALTIME_ISSUES'
export const ADD_REALTIME_ISSUE = 'ADD_REALTIME_ISSUE'
export const SHOW_FEEDBACK_POPUP = 'SHOW_FEEDBACK_POPUP'
export const SHOW_SUPPORT_POPUP = 'SHOW_SUPPORT_POPUP'
// ALERTS
export const SET_ALERTS = 'SET_ALERTS'
export const ADD_ALERT = 'ADD_ALERT'
export const DELETE_ALERT = 'DELETE_ALERT'
export const UPDATE_ALERT = 'UPDATE_ALERT'
// ANOMALIES
export const SET_ANOMALIES = 'SET_ANOMALIES'
export const ADD_ANOMALIES = 'ADD_ANOMALIES'
export const UPDATE_ANOMALY = 'UPDATE_ANOMALY'
export const CLEAR_ANOMALIES = 'CLEAR_ANOMALIES'
// WEBCHECKS
export const SET_WEBCHECKS = 'SET_WEBCHECKS'
// ON BOARDING WIZARD
export const SET_ON_BOARDING = 'SET_ON_BOARDING'
export const SET_PAGE_TITLE = 'SET_PAGE_TITLE'
// ALERT DIALOG
export const SET_DUPLICATE_SERVER = 'SET_DUPLICATE_SERVER'

export const mutations = {
  [SET_BUCKET](state, { bucketState, serverStatuses, frontendMetrics }) {
    bucketState = updateBucketState(bucketState, serverStatuses, frontendMetrics)
    const existingBucket = state.buckets[bucketState.bucket.id]
    if (!existingBucket) {
      Vue.set(state.buckets, bucketState.bucket.id, bucketState)
    } else {
      Object.assign(existingBucket, bucketState)
    }
  },
  [SET_CURRENT_BUCKET_ID](state, { bucketId }) {
    state.currentBucketId = bucketId
  },
  [SET_CURRENT_APP_NAME](state, { appName }) {
    state.maybeCurrentAppName = appName
  },
  [UPDATE_SERVER](state, { server, bucketId }) {
    if (_.isEmpty(state.buckets)) return
    state.buckets[bucketId].servers[server.hostname] = server
  },
  [SET_USER](state, { user }) {
    state.user = user
  },
  [SET_STATUS](state, { status }) {
    state.status = status
  },
  [SET_SERVERS_COUNT](state, { serversCount }) {
    state.serversCount = serversCount
  },
  [SET_APPS_COUNT](state, { appsCount }) {
    state.appsCount = appsCount
  },
  [SET_HAS_SEEN_WIZARD](state, { hasSeenWizard }) {
    state.hasSeenWizard = hasSeenWizard
    window.localStorage.setItem('hasSeenWizard', JSON.stringify(hasSeenWizard))
  },
  [SET_PLANS](state, { plans }) {
    state.plans = Object.freeze(plans)
  },
  [SET_THEME](state, { theme }) {
    state.theme = theme
  },
  [ADD_CPU_PROFILE](state, { profile, bucketId = state.currentBucketId }) {
    const profiles = state.buckets[bucketId].ui.cpuProfilingPage.profiles
    profiles.push(profile)
  },
  [UPDATE_CPU_PROFILE](state, { profile, index, bucketId = state.currentBucketId }) {
    const profiles = state.buckets[bucketId].ui.cpuProfilingPage.profiles
    profiles.splice(index, 1)
    profiles.push(profile)
  },
  [ADD_MEM_SNAPSHOT](state, { snapshot, bucketId = state.currentBucketId }) {
    const snapshots = state.buckets[bucketId].ui.memProfilingPage.snapshots
    snapshots.push(snapshot)
  },
  [UPDATE_MEM_SNAPSHOT](state, { snapshot, index, bucketId = state.currentBucketId }) {
    const snapshots = state.buckets[bucketId].ui.memProfilingPage.snapshots
    snapshots.splice(index, 1)
    snapshots.push(snapshot)
  },
  [ADD_HEAP_PROFILE](state, { profile, bucketId = state.currentBucketId }) {
    const profiles = state.buckets[bucketId].ui.heapProfilingPage.profiles
    profiles.push(profile)
  },
  [UPDATE_HEAP_PROFILE](state, { profile, index, bucketId = state.currentBucketId }) {
    const profiles = state.buckets[bucketId].ui.heapProfilingPage.profiles
    profiles.splice(index, 1)
    profiles.push(profile)
  },
  [CLEAR_CPU_PROFILES](state, { bucketId = state.currentBucketId }) {
    state.buckets[bucketId].ui.cpuProfilingPage.profiles = []
  },
  [CLEAR_HEAP_PROFILES](state, { bucketId = state.currentBucketId }) {
    state.buckets[bucketId].ui.heapProfilingPage.profiles = []
  },
  [CLEAR_MEM_SNAPSHOTS](state, { bucketId = state.currentBucketId }) {
    state.buckets[bucketId].ui.memProfilingPage.snapshots = []
  },
  [SET_PROFILING_HISTORY](state, { bucketId = state.currentBucketId, profilings }) {
    state.buckets[bucketId].profilings = profilings
  },
  [DELETE_PROFILING](state, { bucketId = state.currentBucketId, filename }) {
    const index = state.buckets[bucketId].profilings.data.findIndex(
      profiling => profiling.filename === filename,
    )
    state.buckets[bucketId].profilings.data.splice(index, 1)
    state.buckets[bucketId].profilings.total -= 1
  },
  [SET_TOKENS](state, { tokens }) {
    state.tokens = tokens
  },
  [ADD_TOKEN](state, { token }) {
    token.client = 'PersonalTokens'
    state.tokens.push(token)
  },
  [REMOVE_TOKEN](state, { id }) {
    const i = state.tokens.findIndex(token => token.id === id)
    if (i === -1) return
    state.tokens.splice(i, 1)
  },
  [SET_OTP](state, { otp }) {
    state.otp = otp
  },
  [REMOVE_PROVIDER](state, { name }) {
    const providers = state.user.providers
    const i = providers.findIndex(p => p.name === name)
    if (i === -1) return
    providers.splice(i, 1)
    Vue.set(state.user, 'providers', providers)
  },
  [UPDATE_ALERTS](state, { bucketId = state.currentBucketId, triggers }) {
    Vue.set(state.buckets[bucketId].bucket, 'triggers', triggers)
  },
  [UPDATE_SLACK](state, { bucketId = state.currentBucketId, slack }) {
    Vue.set(state.buckets[bucketId].bucket.integrations, 'slack', slack)
  },
  [UPDATE_WEBHOOK](state, { bucketId = state.currentBucketId, webhook }) {
    Vue.set(state.buckets[bucketId].bucket.integrations, 'webhooks', webhook)
  },
  [SET_CRITICAL_RESOURCES_FETCHED](state, { areCriticalResourcesFetched }) {
    state.areCriticalResourcesFetched = areCriticalResourcesFetched
  },
  [SET_BILLING_CARDS](state, { bucketId, cards, defaultCard }) {
    cards.forEach((card, i) => {
      if (card.id === defaultCard.id) cards[i].default = true
    })
    Vue.set(state.buckets[bucketId].billing, 'cards', cards)
  },
  [ADD_BILLING_CARD](state, { bucketId, card }) {
    const cards = state.buckets[bucketId].billing.cards
    if (!cards.length) card.default = true
    cards.push(card)
    Vue.set(state.buckets[bucketId].billing, 'cards', cards)
  },
  [REMOVE_BILLING_CARD](state, { bucketId, token }) {
    const cards = state.buckets[bucketId].billing.cards
    const i = cards.findIndex(c => c.id === token)
    if (i === -1) return
    cards.splice(i, 1)
    Vue.set(state.buckets[bucketId].billing, 'cards', cards)
  },
  [SET_DEFAULT_BILLING_CARD](state, { bucketId, token }) {
    const cards = state.buckets[bucketId].billing.cards
    cards.forEach((card, i) => {
      if (card.id === token) cards[i].default = true
      else delete cards[i].default
    })
    Vue.set(state.buckets[bucketId].billing, 'cards', cards)
  },
  [SET_BILLING_INVOICES](state, { bucketId, invoices }) {
    state.buckets[bucketId].billing.invoices = invoices
  },
  [SET_BILLING_RECEIPTS](state, { bucketId, receipts }) {
    state.buckets[bucketId].billing.receipts = receipts
  },
  [SET_BILLING_COUPON](state, { bucketId = state.currentBucketId, coupon }) {
    state.buckets[bucketId].billing.coupon = coupon
  },
  [SET_BILLING_META](state, { bucketId = state.currentBucketId, meta }) {
    state.buckets[bucketId].billing.meta = meta
  },
  [SET_BILLING_META_VATNUMBER](state, { bucketId = state.currentBucketId, vatNumber }) {
    Vue.set(state.buckets[bucketId].billing.meta.metadata, 'vat_number', vatNumber)
  },
  [SET_BILLING_META_COMPANYNAME](state, { bucketId = state.currentBucketId, companyName }) {
    Vue.set(state.buckets[bucketId].billing.meta.metadata, 'company_name', companyName)
  },
  [SET_BILLING_META_RECEIPTEMAIL](state, { bucketId = state.currentBucketId, receiptEmail }) {
    Vue.set(state.buckets[bucketId].billing.meta.metadata, 'receipt_email', receiptEmail)
  },
  [SET_PAGE_LOADING](state, { isPageLoading }) {
    state.isPageLoading = isPageLoading
  },
  [SET_PREFERRED_METRICS](state, { bucketId = state.currentBucketId, appName, metrics }) {
    // Data storage migration
    if (state.preferredMetrics.length && !Array.isArray(state.preferredMetrics[0].metrics)) {
      state.preferredMetrics = []
    }

    const existing = state.preferredMetrics.find(
      entry => entry.bucketId === bucketId && entry.appName === appName,
    )
    if (existing) {
      existing.metrics = metrics
    } else {
      state.preferredMetrics.push({ bucketId, appName, metrics })
    }
  },
  [SET_SELECTED_VARIANCE](state, { bucketId, value }) {
    state.buckets[bucketId].selectedVariance = value
  },
  [SET_AUTHORIZED_USERS](state, { bucketId = state.route.params.id, users }) {
    state.buckets[bucketId].authorizedUsers = users
  },
  [REMOVE_AUTHORIZED_USER](state, { bucketId = state.currentBucketId, email }) {
    const users = state.buckets[bucketId].authorizedUsers
    const i = users.findIndex(user => user.email === email)
    if (i === -1) return
    users.splice(i, 1)
  },
  [SET_USER_NOTIFICATION](state, { bucketId = state.currentBucketId, email, notifState }) {
    const i = state.buckets[bucketId].authorizedUsers.findIndex(user => user.email === email)
    state.buckets[bucketId].authorizedUsers[i].notifications = notifState
  },
  [SET_USER_ROLE](state, { bucketId = state.currentBucketId, email, role }) {
    const i = state.buckets[bucketId].authorizedUsers.findIndex(user => user.email === email)
    state.buckets[bucketId].authorizedUsers[i].role = role
  },
  [SET_INVITATIONS](state, { bucketId = state.currentBucketId, invitations }) {
    state.buckets[bucketId].bucket.invitations = invitations
  },
  [UPDATE_BUCKET](state, { bucketId, bucket }) {
    state.buckets[bucketId].bucket = bucket
  },
  [UPDATE_BUCKET_NAME](state, { bucketId = state.currentBucketId, name }) {
    state.buckets[bucketId].bucket.name = name
  },
  [UPDATE_BUCKET_COMMENT](state, { bucketId = state.currentBucketId, comment }) {
    state.buckets[bucketId].bucket.comment = comment
  },
  [UPDATE_LOCALE](state, { locale }) {
    state.locale = locale
  },
  [DELETE_BUCKET](state, { bucketId }) {
    delete state.buckets[bucketId]
  },
  [ADD_LINKED_SERVER](state, { bucketId = state.currentBucketId, server }) {
    state.buckets[bucketId].serversLinked.push(server)
  },
  [SET_ACTIVATE_PM2](state, { opened, position }) {
    state.activatePM2 = { isOpen: opened, position }
  },
  [SET_UPGRADE_STEPPER](state, { opened }) {
    state.upgradeStepper = opened
  },
  [SET_PROCESS_BLACKLIST](state, { bucketId, blacklist }) {
    state.buckets[bucketId].processBlacklist = blacklist
  },
  [REMOVE_SERVER](state, { bucketId = state.currentBucketId, serverName }) {
    const bucketState = state.buckets[bucketId]
    if (bucketState) {
      bucketState.processes = bucketState.processes.filter(process => process.server !== serverName)
      bucketState.servers = bucketState.servers.filter(server => server.server_name !== serverName)
    }
  },
  [ADD_EMITTED_EVENT](state, { event }) {
    if (!state.emittedEvents.includes(event)) state.emittedEvents.push(event)
  },
  [SET_IS_PORTAL_OPEN](state, { isOpen, initialInput = '' }) {
    state.portal.isOpen = isOpen
    state.portal.initialInput = initialInput
  },
  [UPDATE_TIMESTAMP](state) {
    state.timestamp = Date.now()
  },
  [SET_NAV_TO_HINT](state, { hint }) {
    state.navToHint = hint
  },
  [SET_REALTIME_ISSUES](state, { bucketId = state.currentBucketId, issues }) {
    state.buckets[bucketId].realtimeIssues = issues
  },
  [ADD_REALTIME_ISSUE](state, { bucketId = state.currentBucketId, issues }) {
    state.buckets[bucketId].realtimeIssues = state.buckets[bucketId].realtimeIssues.concat(issues)
  },
  [SHOW_FEEDBACK_POPUP](state, { show }) {
    state.showFeedbackPopup = show
    if (show) state.showSupportPopup = false
  },
  [SHOW_SUPPORT_POPUP](state, { show }) {
    state.showSupportPopup = show
    if (show) state.showFeedbackPopup = false
  },
  [SET_ALERTS](state, { bucketId = state.currentBucketId, alerts }) {
    const normAlerts = normalize(alerts, [Alert]).entities.alerts || {}
    state.buckets[bucketId].alerts = normAlerts
  },
  [ADD_ALERT](state, { bucketId = state.currentBucketId, alert }) {
    Vue.set(state.buckets[bucketId].alerts, alert.id, alert)
  },
  [DELETE_ALERT](state, { bucketId = state.currentBucketId, alertId }) {
    Vue.delete(state.buckets[bucketId].alerts, alertId)
  },
  [UPDATE_ALERT](state, { bucketId = state.currentBucketId, alert }) {
    state.buckets[bucketId].alerts[alert.id] = alert
  },
  [SET_ANOMALIES](state, { bucketId = state.currentBucketId, anomalies }) {
    state.buckets[bucketId].anomalies = anomalies
  },
  [ADD_ANOMALIES](state, { bucketId = state.currentBucketId, anomalies }) {
    state.buckets[bucketId].anomalies = state.buckets[bucketId].anomalies.concat(...anomalies)
  },
  [UPDATE_ANOMALY](state, { bucketId = state.currentBucketId, anomaly }) {
    state.buckets[bucketId].anomalies = state.buckets[bucketId].anomalies.map(an => {
      return an.id === anomaly.id ? anomaly : an
    })
  },
  [CLEAR_ANOMALIES](state, { bucketId = state.currentBucketId }) {
    state.buckets[bucketId].anomalies = []
  },
  [SET_WEBCHECKS](state, { bucketId = state.currentBucketId, webchecks }) {
    state.buckets[bucketId].webchecks = webchecks
  },
  [SET_ON_BOARDING](state, { bucketId = state.currentBucketId, isOpen }) {
    state.isOnBoardingOpen = isOpen
  },
  [SET_PAGE_TITLE](state, { title }) {
    state.pageTitle = title
  },
  [SET_DUPLICATE_SERVER](state, data) {
    state.hasDuplicatedServer = data
  }
}
